import React, { useState } from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { PlusIcon, CreditCardIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
export function VirtualCard() {
  const [showCardDetails, setShowCardDetails] = useState(false);
  return <div data-id="element-650">
      <PageHeader title="Virtual Cards" description="Manage your virtual cards for secure online transactions" data-id="element-651" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-652">
        <div className="lg:col-span-2" data-id="element-653">
          <Card title="My Virtual Cards" data-id="element-654">
            <div className="mb-6 relative" data-id="element-655">
              <div className="bg-gradient-to-r from-blue-500 to-blue-700 rounded-xl p-6 text-white shadow-lg" data-id="element-656">
                <div className="flex justify-between" data-id="element-657">
                  <div data-id="element-658">
                    <p className="text-sm opacity-80" data-id="element-659">Balance</p>
                    <p className="text-2xl font-bold" data-id="element-660">$2,450.25</p>
                  </div>
                  <div data-id="element-661">
                    <CreditCardIcon className="h-8 w-8" data-id="element-662" />
                  </div>
                </div>
                <div className="mt-8" data-id="element-663">
                  <p className="text-sm opacity-80" data-id="element-664">Card Number</p>
                  <p className="text-lg tracking-wider" data-id="element-665">
                    {showCardDetails ? '4562 1122 4594 7852' : '•••• •••• •••• 7852'}
                  </p>
                </div>
                <div className="mt-4 flex justify-between" data-id="element-666">
                  <div data-id="element-667">
                    <p className="text-sm opacity-80" data-id="element-668">Expiry Date</p>
                    <p data-id="element-669">{showCardDetails ? '05/25' : '••/••'}</p>
                  </div>
                  <div data-id="element-670">
                    <p className="text-sm opacity-80" data-id="element-671">CVV</p>
                    <p data-id="element-672">{showCardDetails ? '123' : '•••'}</p>
                  </div>
                  <div data-id="element-673">
                    <button onClick={() => setShowCardDetails(!showCardDetails)} className="p-2 bg-white bg-opacity-20 rounded-full" data-id="element-674">
                      {showCardDetails ? <EyeOffIcon className="h-5 w-5" data-id="element-675" /> : <EyeIcon className="h-5 w-5" data-id="element-676" />}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-4" data-id="element-677">
              <h3 className="text-lg font-medium" data-id="element-678">Recent Transactions</h3>
              {[{
              merchant: 'Netflix',
              amount: '$12.99',
              date: 'Jul 15, 2023',
              status: 'Completed'
            }, {
              merchant: 'Amazon',
              amount: '$34.76',
              date: 'Jul 12, 2023',
              status: 'Completed'
            }, {
              merchant: 'Spotify',
              amount: '$9.99',
              date: 'Jul 01, 2023',
              status: 'Completed'
            }].map((transaction, i) => <div key={i} className="flex justify-between items-center border-b pb-3" data-id="element-679">
                  <div data-id="element-680">
                    <p className="font-medium" data-id="element-681">{transaction.merchant}</p>
                    <p className="text-sm text-gray-500" data-id="element-682">{transaction.date}</p>
                  </div>
                  <div className="text-right" data-id="element-683">
                    <p className="font-medium" data-id="element-684">{transaction.amount}</p>
                    <p className="text-sm text-green-600" data-id="element-685">
                      {transaction.status}
                    </p>
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
        <div data-id="element-686">
          <Card title="Card Actions" data-id="element-687">
            <div className="space-y-4" data-id="element-688">
              <button className="w-full flex justify-center items-center px-4 py-3 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-689">
                <PlusIcon className="mr-2 h-5 w-5" data-id="element-690" />
                Create New Card
              </button>
              <button className="w-full flex justify-center items-center px-4 py-3 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-691">
                Fund Card
              </button>
              <button className="w-full flex justify-center items-center px-4 py-3 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-692">
                Freeze Card
              </button>
              <button className="w-full flex justify-center items-center px-4 py-3 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-red-600 bg-white hover:bg-red-50" data-id="element-693">
                Delete Card
              </button>
            </div>
          </Card>
          <Card title="Card Limits" className="mt-6" data-id="element-694">
            <div className="space-y-4" data-id="element-695">
              <div data-id="element-696">
                <div className="flex justify-between mb-1" data-id="element-697">
                  <span className="text-sm font-medium text-gray-700" data-id="element-698">
                    Daily Spending
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-699">
                    $120 / $500
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-700">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: '24%'
                }} data-id="element-701"></div>
                </div>
              </div>
              <div data-id="element-702">
                <div className="flex justify-between mb-1" data-id="element-703">
                  <span className="text-sm font-medium text-gray-700" data-id="element-704">
                    Monthly Spending
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-705">
                    $850 / $5,000
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-706">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: '17%'
                }} data-id="element-707"></div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}